import { Dispatch, ReactElement } from 'react';
import { Checkbox, styled } from '@mui/material';
import {
  deaNumUsersAllSelected,
  formatDate,
  formatDateUTC,
  IDeaNumUser,
  includes,
  mapRole,
  parseDate,
  variables,
} from '../common';
import { TeamRequestAction } from '.';
import { map as lmap } from 'lodash/fp';
import { getLabelByValueRa, getLabelByValueDi } from '../admin';

export const UserRoles2d = ({
  deaNumUsers,
  deaNumUsersKeysAll,
  selectedUserRoleKeys,
  enableAll,
  dispatchTeamRequest,
}: {
  deaNumUsers: IDeaNumUser[];
  deaNumUsersKeysAll: string[];
  selectedUserRoleKeys: string[];
  enableAll: boolean;
  dispatchTeamRequest: Dispatch<TeamRequestAction>;
}) => (
  <Articl>
    <h4 key={0}>
      {enableAll && (
        <Checkbox
          color="primary"
          onClick={() =>
            dispatchTeamRequest({ type: 'ToggleUserRole', payload: deaNumUsersKeysAll })
          }
          checked={deaNumUsersAllSelected({
            deaNumUsers,
            selectedUserRoleKeys,
          })}
        />
      )}
    </h4>
    <h4>DEA Registration Number</h4>
    <h4 key={1}>Name</h4>
    <h4 key={2}>Serial Number</h4>
    <h4 key={3}>Certificate Status</h4>
    <h4 key={4}>Expiration Date</h4>
    <h4 key={5}>Role</h4>
    <h4 key={6}>First Name</h4>
    <h4 key={7}>Last Name</h4>
    <h4 key={8}>Email</h4>
    {lmap<IDeaNumUser, ReactElement[]>(
      ({ deaNumber, serialNumber, role, firstName, lastName, loginEmail, key, certExpDt, certStatus }) => [
        <span>
          <Checkbox
            color="primary"
            onClick={() =>
              dispatchTeamRequest({ type: 'ToggleUserRole', payload: key })
            }
            checked={includes(selectedUserRoleKeys)(key)}
          />
        </span>,
        <span>{deaNumber}</span>,
        <span>{firstName} {lastName}</span>,
        <span>{serialNumber}</span>,
        <span>{getLabelByValueRa(certStatus)}</span>,
        <span>{certExpDt ? formatDateUTC(certExpDt): null}</span>,
        <span>{mapRole(role)}</span>,
        <span>{firstName}</span>,
        <span>{lastName}</span>,
        <span>{loginEmail}</span>,
      ]
    )(deaNumUsers)}
  </Articl>
);

const Articl = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '1rem',
  },

  '@media (min-width: 60em)': {
    display: 'grid',
    gridTemplateColumns: '5.5rem repeat(9, auto)',
    gap: '1px',

    backgroundColor: variables.grayLighter,
    border: variables.cardBorder,
    borderRadius: variables.cardBorderRadius,

    '&>*': {
      backgroundColor: '#fff',
      padding: '1rem',
    },

    '&>*+*': {
      marginTop: '0rem',
    },
  },
}));
